/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, bool, func, string,
} from 'prop-types';
import { withRouter } from 'react-router';

import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import CloseIcon from '@material-ui/icons/Close';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = () => ({
    closeButton: {
        textAlign: 'right',
        margin: '5px 5px 0 0',
    },
    productImg: {
        padding: '25px 40px',
    },
});

const ImageModal = ({
    classes,
    isOpen,
    onClose,
    productImageURL,
    productSku,
}) => (
    <Dialog
        open={isOpen}
        onClose={onClose}
    >
        <Grid item onClick={onClose} className={classes.closeButton}>
            <CloseIcon />
        </Grid>
        <Grid item>
            <img className={classes.productImg} src={productImageURL} alt={productSku} />
        </Grid>
    </Dialog>
);

ImageModal.propTypes = {
    isOpen: bool.isRequired,
    onClose: func.isRequired,
    classes: object.isRequired,
    productImageURL: string.isRequired,
    productSku: string.isRequired,
};

export default withRouter(
    (withStyles(styles)(ImageModal)),
);
